<div [ngClass]="getClasses()" style="min-width: 800px;">
  <ng-content></ng-content>
</div>
